module.exports = __webpack_public_path__ + "img/round-header-background.e2df6ff3.svg";